var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 41.861 41.861"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "facebook_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h41.861v41.861H0z",
  "data-name": "Rectangle 7491"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 18690"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#facebook_svg__a)",
  "data-name": "Group 18689"
}, /*#__PURE__*/React.createElement("path", {
  d: "m25.659 22.2.564-3.678h-3.528v-2.385a1.84 1.84 0 0 1 2.073-1.987h1.6v-3.131a19.6 19.6 0 0 0-2.848-.248c-2.906 0-4.805 1.761-4.805 4.949v2.8h-3.23v3.68h3.23v8.89h3.976V22.2Z",
  "data-name": "Path 27240"
})))));
export { SvgFacebook as ReactComponent };
export default __webpack_public_path__ + "static/media/facebook.8290a9421a25e5f3b8fd46ab83b48cf7.svg";